<template>
  <div class="content" id="login-content">
    <router-link to="/">
      <img class="logo" src="/static/logo.png" />
    </router-link>
    <el-form ref="form" :rules="rules" :model="form">
      <div class="form-warp">
        <div class="title">{{$t('global.注册')}}</div>
        <div class="form">
          <div class="sub_title">
            <span :class="{active:regType === 1}" @click="chooseType(1)">
              <a href="javascript:;">{{$t('global.手机号注册')}}</a>
            </span>
            <span :class="{active:regType === 2}" @click="chooseType(2)">
              <a href="javascript:;">{{$t('global.邮箱注册')}}</a>
            </span>
          </div>
          <div class="label phoneWarp" v-if="regType=== 1">
            <el-select
              v-model="form.areaCode"
              filterable
              remote
              :remote-method="getSearch"
              :placeholder="$t('global.请选择区号')"
              class="areaCode"
            >
              <el-option
                :label="item.areaCode"
                :value="item.areaCode"
                v-for="item in areaCodeList"
                :key="item.id"
              >
                <p>
                  {{item.title}}
                  <span style="padding-left:10px;float: right;">{{item.areaCode}}</span>
                </p>
              </el-option>
            </el-select>

            <el-form-item prop="phone" class="phone">
              <el-input
                type="tel"
                v-model="form.phone"
                autocomplete="new-password"
                :placeholder="$t('global.手机号')"
              ></el-input>
            </el-form-item>
          </div>
          <div class="label" v-if="regType=== 2">
            <el-form-item prop="email" class="email">
              <el-input
                type="email"
                v-model="form.email"
                autocomplete="new-password"
                :placeholder="$t('global.邮箱')"
              ></el-input>
            </el-form-item>
          </div>
          <div class="label">
            <el-form-item prop="phoneCode" class="phoneCode">
              <el-input
                type="number"
                v-model="form.phoneCode"
                autocomplete="new-password"
                :placeholder="$t('global.验证码')"
              ></el-input>
              <a
                href="javascript:;"
                class="sendCode"
                @click.prevent="checkAccount"
              >{{!time?$t('global.获取验证码'):`${time}s${$t('global.后重新获取')}`}}</a>
            </el-form-item>
          </div>
          <el-form-item prop="password">
            <el-input
              :type="pwdType"
              v-model="form.password"
              autocomplete="new-password"
              :placeholder="$t('global.密码')"
            ></el-input>
            <i
              v-if="this.pwdType !== 'password'"
              class="el-icon-view password-view"
              @click="changeType(1)"
            ></i>
            <i v-else class="iconfont password-view" @click="changeType(1)">&#xe6d0;</i>
          </el-form-item>
          <div class="div-rememberme">
            <span
              @click="dialogVisible = true"
              class="agreement"
            >{{$t('global.注册即表示同意')}}《MANA{{$t('global.用户协议')}}》</span>
            <el-dialog :visible.sync="dialogVisible" :show-close="false" width="60%">
              <h2 v-html="agreement.title"></h2>
              <div v-html="agreement.body" class="agreementContent"></div>
            </el-dialog>
          </div>
          <el-button type="primary" class="btn-login" @click="register">{{$t('global.注册')}}</el-button>
          <div class="login-text">
            {{$t('global.已经有MANA账户了吗，')}}
            <router-link class="reg-link" to="/login">{{$t('global.立即登录')}}</router-link>
          </div>
        </div>
      </div>
    </el-form>
    <div class="footer-row">
      <div class="footer-copyright">
        Copyright 2016-{{dataYear}} 吗呐（MANA）All Rights Reserved.
        <a
          href="http://beian.miit.gov.cn/"
          target="_blank"
        >沪ICP备16019863号</a>
        <img src="/static/police.png" />
        <a
          href="https://beian.mps.gov.cn/#/query/webSearch?code=31010402333867" target="_blank"
        >沪公网安备 31010402333867号</a>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "reg",
  metaInfo() {
    return {
      title: this.$t("global.注册") + " | MANA"
    };
  },
  data() {
    return {
      dataYear: null,
      email: "",
      password: "",
      pwdType: "password",
      dialogVisible: false,
      regType: 1,
      areaCodeList: [],
      time: 0,
      agreement: {
        title: "",
        body: ""
      },
      form: {
        areaCode: "86",
        email: "",
        password: "",
        phoneCode: ""
      },
      rules: {
        email: [
          {
            required: true,
            message: this.$t("global.邮箱不能为空"),
            trigger: "blur"
          },
          {
            type: "email",
            message: this.$t("global.不是有效的邮箱地址"),
            trigger: "blur"
          }
        ],
        password: [
          {
            required: true,
            message: this.$t("global.密码不能为空"),
            trigger: "blur"
          },
          {
            validator: (rule, value, callback) => {
              if (!/\S{7,}/.test(value) && !/^\d+$/.test(value)) {
                callback(
                  new Error(this.$t("global.密码不少于7位，且不能为纯数字"))
                );
                return;
              }
              callback();
            },
            trigger: "blur"
          }
        ],
        phoneCode: [
          {
            required: true,
            message: this.$t("global.验证码不能为空"),
            trigger: "blur"
          },
          {
            validator: (rule, value, callback) => {
              const reg = /^\d{6}/;
              if (!reg.test(value)) {
                callback(new Error(this.$t("global.请输入正确的6位验证码")));
                return;
              }
              callback();
            },
            trigger: "blur"
          }
        ],
        phone: [
          {
            required: true,
            message: this.$t("global.手机号不能为空"),
            trigger: "blur"
          },
          {
            validator: (rule, value, callback) => {
              const reg = /^\d{5,}/;
              if (!reg.test(value)) {
                callback(new Error(this.$t("global.请输入正确的手机号")));
                return;
              }
              callback();
            },
            message: this.$t("global.请输入正确的手机号"),
            trigger: "blur"
          }
        ]
      }
    };
  },
  created() {
    this.init();
    var date = new Date();
    this.dataYear = date.getFullYear();
  },
  watch: {
    time(val) {
      if (val >= 1) {
        setTimeout(() => {
          this.time--;
        }, 1000);
      }
    }
  },
  methods: {
    init() {
      this.getAreaCodeList("");
      this.$http
        .get("/api/common/page", {
          params: {
            title: this.language === "zh" ? "用户协议" : "Terms of Use"
          }
        })
        .then(res => {
          if (res.code === "OK") {
            this.agreement.title = res.data.title;
            this.agreement.body = res.data.body;
          }
        });
    },
    changeType(type) {
      this.pwdType = this.pwdType === "password" ? "text" : "password";
    },
    checkAccount() {
      let params = {
        userName: this.form.email,
        type: this.regType
      };
      if (this.regType === 1) {
        params.areaCode = "+" + this.form.areaCode;
        params.userName = this.form.phone;
      }
      const url = `/api/passport/checEmailOrPhone`;
      this.$http.post(url, params).then(res => {
        if (res.code === "OK") {
          /**
           *  data
           *  0 === 可以注册
           *  1 === 已有用户
           */
          if (!res.data) {
            this.sendPhoneCode();
          } else if (res.data === 1) {
            this.$message(
              `${this.$t("global.已存在该账号")},${this.$t(
                "global.请直接登录"
              )}`
            );
          }
        }
      });
    },
    sendPhoneCode() {
      let params;
      if (
        this.form.areaCode &&
        this.form.phone &&
        /^\d*$/.test(this.form.phone)
      ) {
        params = {
          type: 1,
          phone: this.form.phone,
          areaCode: "+" + this.form.areaCode
        };
      } else if (this.form.email) {
        params = {
          type: 2,
          phone: this.form.email
        };
      }
      const url = `/api/customer/sendPhoneOrEmailCode`;
      this.$http.post(url, params).then(res => {
        if (res.code === "OK") {
          this.time = 60;
          this.$message.success(res.message);
        } else {
          this.$message.error(this.$t("global.发送失败"));
        }
      });
    },
    getAreaCodeList(val) {
      let config = {
        loading: false,
        params: {
          keyWords: val || undefined,
          pageSize: 500,
          pageIndex: 1,
          orderBy: "createTime"
        }
      };
      let $this = this;
      this.$http.get("/api/areacode/areaCodeList", config).then(response => {
        this.areaCodeList = response.data.list;
      });
    },
    getSearch(val) {
      if (!val) {
        this.getAreaCodeList("");
      } else {
        this.areaCodeList = this.areaCodeList.filter(item => {
          return (
            item.title.indexOf(val.toUpperCase()) > -1 ||
            item.areaCode.indexOf(val) > -1
          );
        });
      }
    },
    chooseType(index) {
      this.regType = index;
    },
    register() {
      this.$refs["form"].validate(valid => {
        if (valid) {
          let params1;
          if (this.regType === 1) {
            params1 = {
              phone: this.form.phone,
              code: this.form.phoneCode,
              areaCode: "+" + this.form.areaCode,
              type: 1
            };
          } else {
            params1 = {
              phone: this.form.email,
              code: this.form.phoneCode,
              type: 2
            };
          }
          const url1 = `/api/passport/checkCodeNoLogin`;
          this.$http.post(url1, params1).then(res => {
            if (res.code === "OK") {
              const data = res.data;
              if (data.isNew === 1) {
                const url = `/api/passport/phone_login`;
                const params = {
                  regSource: "PC",
                  password: this.form.password
                };
                if (this.regType === 1) {
                  params.phone = this.form.phone;
                  params.areaCode = "+" + this.form.areaCode;
                } else {
                  params.email = this.form.email;
                }
                this.$http.post(url, params).then(res => {
                  if (res.code === "OK") {
                    this.$store.dispatch("setNewState", {
                      peopleMessage: res.data,
                      isLogin: false
                    });
                    this.$message({
                      message: `${this.$t("global.注册成功")},${this.$t(
                        "global.请完善个人信息"
                      )}`,
                      type: "success"
                    });
                    this.$router.push(
                      `/setInfo/nickname?userId=${res.data.userId}`
                    );
                    localStorage.setItem("auth_token", res.data.token);
                    localStorage.setItem("userId", res.data.userId);
                  }
                });
              } else {
                this.$message.error(
                  `${this.$t("global.该账户已存在")},${this.$t(
                    "global.请直接登录"
                  )}`
                );
                setTimeout(() => {
                  this.$router.replace("/login");
                }, 1000);
              }
            }
          });
        }
      });
    }
  },
  computed: {
    language() {
      return this.$language();
    }
  }
};
</script>

<style scoped>
.phoneWarp {
  display: flex;
  flex-direction: row;
}
.phoneWarp .areaCode {
  width: 100px;
}
.phoneWarp .phone {
  width: calc(330px - 100px);
  margin-left: 5px;
}
.sendCode {
  position: absolute;
  right: 20px;
  top: 25px;
  color: #5f86fc;
}

.sendCode.disabled {
  color: #999;
}
.form {
  width: 330px;
  height: 440px;
  padding: 40px;
  border-radius: 10px;
  background-color: rgba(0, 0, 0, 0.4);
}
.sub_title {
  line-height: 40px;
  display: flex;
  flex-direction: row;
  align-items: center;
}
.sub_title span {
  flex: 1;
  text-align: center;
}
.sub_title span a {
  color: #ccc;
  font-size: 24px;
  line-height: 40px;
  display: inline-block;
}
.sub_title span.active a {
  font-weight: 600;
  color: #fff;
  border-bottom: 1px solid #fff;
}

.form-warp {
  overflow: auto;
  position: absolute;
  width: 410px;
  height: 650px;
  left: 0;
  right: 0;
  top: 0;
  bottom: 0;
  margin: auto;
}
.div-rememberme >>> h2 {
  font-size: 16px;
  border-left: 4px solid #0060ff;
  padding-left: 10px;
  margin-bottom: 30px;
}
.agreementContent >>> p {
  color: #7d7d7d;
  font-size: 14px;
  line-height: 25px;
  margin-bottom: 10px;
}
.agreementContent >>> span {
  display: block;
}
.agreementContent >>> .font-weight {
  font-weight: bold;
}
.div-rememberme >>> .el-dialog__body {
  height: 7.2rem;
  overflow-y: auto;
}
.div-rememberme >>> .el-dialog {
  border-radius: 0.2rem;
  padding-bottom: 0.4rem;
}
.content >>> .el-form-item__error {
  font-size: 0.18rem;
  font-weight: bold;
}
.el-form-item >>> .el-input__inner {
  height: 50px;
  border: 0.02rem solid white;
  box-sizing: border-box;
  line-height: 0.6rem;
  font-size: 0.2rem;
  background-color: transparent;
  width: 100%;
  padding: 0 0.28rem;
  -webkit-border-radius: 0.06rem;
  -moz-border-radius: 0.06rem;
  border-radius: 0.06rem;
  margin-top: 20px !important;
  color: #fff;
}
.logo {
  position: absolute;
  left: 1.8rem;
  top: 0.3rem;
  display: inline-block;
  width: 1.3rem;
  height: 0.34rem;
}
.content {
  width: 100%;
  height: 100vh;
  background: url("/static/login/login-back.jpg") no-repeat center center;
  background-size: cover;
  padding-top: 4.2rem;
  position: relative;
  box-sizing: border-box;
}
.content:before {
  content: "";
  position: absolute;
  display: block;
  left: 0;
  right: 0;
  top: 0;
  bottom: 0;
  background-color: rgba(0, 0, 0, 0.4);
}

.title {
  color: #fff;
  font-size: 0.36rem;
  text-align: center;
  margin-bottom: 10px;
}

.form >>> .el-input__inner {
  height: 50px;
  border: 0.02rem solid white;
  box-sizing: border-box;
  line-height: 0.6rem;
  font-size: 0.2rem;
  background-color: transparent;
  width: 100%;
  padding: 0 0.28rem;
  -webkit-border-radius: 0.06rem;
  -moz-border-radius: 0.06rem;
  border-radius: 0.06rem;
  margin-top: 20px;
  color: #fff;
}

input[type="text"]::-webkit-input-placeholder,
input[type="password"]::-webkit-input-placeholder {
  color: #fff;
}

input[type="text"]:-moz-placeholder,
input[type="password"]:-moz-placeholder {
  color: #fff;
}

input[type="text"]::-moz-placeholder,
input[type="password"]::-moz-placeholder {
  color: #fff;
}

input[type="text"]:-ms-input-placeholder,
input[type="password"]:-ms-input-placeholder {
  color: #fff;
}

.password-view {
  font-size: 0.26rem;
  color: #fff;
  position: absolute;
  right: 0.3rem;
  top: 0.22rem;
  cursor: pointer;
  height: 0.64rem;
  line-height: 0.64rem;
}
.div-rememberme {
  overflow: hidden;
  zoom: 1;
  margin-top: 0.25rem;
}
.div-rememberme > .el-checkbox {
  width: auto;
}
.agreement {
  color: #0161ff;
  font-size: 0.18rem;
  margin-left: 0.1rem;
  cursor: pointer;
}
.forget-link {
  float: right;
  vertical-align: middle;
  font-size: 0.18rem;
  color: #fff;
}
.btn-login {
  width: 100%;
  margin: 0.35rem 0 0.2rem;
}
.login-text {
  font-size: 0.16rem;
  color: #fff;
}
.login-text a {
  color: #0161ff;
  text-decoration: underline;
}
.login-way-title {
  margin: 0.5rem 0 0.35rem;
  text-align: center;
  font-size: 0.18rem;
  color: #999999;
}
.login-ways {
  text-align: center;
}
.login-way {
  display: inline-block;
  width: 0.36rem;
  height: 0.36rem;
  margin: 0 0.275rem;
}
.login-way-qq {
  background: url("/static/qq.png") no-repeat center center;
  background-size: contain;
}
.login-way-wechat {
  background: url("/static/wechat.png") no-repeat center center;
  background-size: contain;
}
.login-way-weibo {
  background: url("/static/weibo.png") no-repeat center center;
  background-size: contain;
}
.footer-row {
  position: absolute;
  width: 100%;
  zoom: 1;
  height: 30px;
  left: 0;
  bottom: 30px;
  text-align: center;
}
.footer-row:after {
  content: "";
  display: block;
  clear: both;
}
.footer-copyright {
  font-size: 0.16rem;
  color: #eee;
  text-align: center;
}
.footer-copyright > a {
  color: #eee;
}
.footer-copyright > img {
  display: inline-block;
  margin: -0.04rem 0.1rem 0;
}

#login-content .el-checkbox {
  min-width: 14px;
  margin-right: 0;
}
</style>



// WEBPACK FOOTER //
// src/pages/passport/Reg.vue